import api from './api'
import { AlteracaoGestao } from '@/types/campanha'
import {
  CandidatoEquipe,
  Equipe,
  EquipeRequest,
  MembroEquipe,
  TipoCandidatoEquipe,
} from '@/types/equipe'

const BASE_URL = '/api/v1/equipes'

/**
 * Equipes do GERENTE (AN-8 §1). Ler: ADMIN todas, GERENTE+GESTOR_EQUIPE só a própria (403
 * EQUIPE_FORA_DO_ESCOPO). Escrever e listar candidatos: ADMIN.
 */
export const equipeService = {
  listar: async (ativa?: boolean): Promise<Equipe[]> => {
    const q = ativa === undefined ? '' : `?ativa=${ativa}`
    return api.get<Equipe[]>(`${BASE_URL}${q}`)
  },

  /** 422 GERENTE_INVALIDO · 409 GERENTE_JA_TEM_EQUIPE. */
  criar: async (req: EquipeRequest): Promise<Equipe> => {
    return api.post<Equipe>(BASE_URL, req)
  },

  /** Troca de nome/gerente vai para a trilha. 422 EQUIPE_INATIVA · 404 EQUIPE_NOT_FOUND. */
  atualizar: async (id: string, req: EquipeRequest): Promise<Equipe> => {
    return api.put<Equipe>(`${BASE_URL}/${id}`, req)
  },

  /** Desativa a equipe e fecha os membros (204). */
  desativar: async (id: string): Promise<void> => {
    await api.delete(`${BASE_URL}/${id}`)
  },

  membros: async (id: string): Promise<MembroEquipe[]> => {
    return api.get<MembroEquipe[]>(`${BASE_URL}/${id}/membros`)
  },

  /** Tudo ou nada: 422 CONSULTOR_INVALIDO · 409 CONSULTOR_JA_EM_EQUIPE. */
  adicionarMembros: async (id: string, consultorIds: string[]): Promise<MembroEquipe[]> => {
    return api.post<MembroEquipe[]>(`${BASE_URL}/${id}/membros`, { consultorIds })
  },

  removerMembro: async (id: string, consultorId: string): Promise<void> => {
    await api.delete(`${BASE_URL}/${id}/membros/${consultorId}`)
  },

  /** Da projeção de usuários (substitui `/v1/usuarios`). ADMIN. */
  candidatos: async (tipo: TipoCandidatoEquipe, busca?: string): Promise<CandidatoEquipe[]> => {
    const params = new URLSearchParams({ tipo })
    if (busca?.trim()) params.append('busca', busca.trim())
    return api.get<CandidatoEquipe[]>(`${BASE_URL}/candidatos?${params.toString()}`)
  },

  alteracoes: async (id: string): Promise<AlteracaoGestao[]> => {
    return api.get<AlteracaoGestao[]>(`${BASE_URL}/${id}/alteracoes`)
  },
}

export default equipeService
